import { render, staticRenderFns } from "./network-connection.vue?vue&type=template&id=67974012"
import script from "./network-connection.vue?vue&type=script&lang=js"
export * from "./network-connection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports